var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRspec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "384pt",
    height: "384pt",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,28.637695%,42.358398%)",
      fillOpacity: 1
    },
    d: "M 248.171875 193.101563 L 190.5 296.910156 L 229.25 194.578125 L 229.839844 193.011719 Z M 248.171875 193.101563 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,28.637695%,42.358398%)",
      fillOpacity: 1
    },
    d: "M 203.148438 199.980469 L 203.03125 200.921875 L 190.5 296.910156 L 177.960938 200.921875 L 177.839844 199.980469 L 190.5 199.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,28.637695%,42.358398%)",
      fillOpacity: 1
    },
    d: "M 151.738281 194.578125 L 190.5 296.910156 L 132.820313 193.101563 L 151.148438 193.011719 Z M 151.738281 194.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,28.637695%,42.358398%)",
      fillOpacity: 1
    },
    d: "M 131.921875 193.550781 L 132.359375 194.449219 L 100.449219 189.011719 L 89.988281 163.511719 L 119.558594 168.871094 L 119.800781 168.910156 L 131.910156 193.550781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,28.637695%,42.358398%)",
      fillOpacity: 1
    },
    d: "M 164.820313 169.46875 L 177.289063 201.011719 L 152.078125 194.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,28.637695%,42.358398%)",
      fillOpacity: 1
    },
    d: "M 216.171875 169.46875 L 228.910156 194.449219 L 203.699219 201.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,28.637695%,42.358398%)",
      fillOpacity: 1
    },
    d: "M 291 163.511719 L 280.539063 189.011719 L 248.628906 194.449219 L 249.070313 193.550781 L 249.078125 193.550781 L 261.191406 168.910156 L 261.429688 168.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,28.637695%,42.358398%)",
      fillOpacity: 1
    },
    d: "M 234.820313 108 L 261.097656 167.050781 L 216.910156 167.109375 L 216.910156 167.101563 L 222.769531 107.890625 L 234.820313 107.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,28.637695%,42.358398%)",
      fillOpacity: 1
    },
    d: "M 164.078125 167.101563 L 190.5 107.890625 L 216.910156 167.101563 L 216.910156 167.109375 L 216.171875 167.109375 L 190.5 167.148438 L 164.820313 167.109375 L 164.078125 167.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,28.637695%,42.358398%)",
      fillOpacity: 1
    },
    d: "M 164.078125 167.101563 L 164.078125 167.109375 L 119.890625 167.050781 L 146.171875 108 L 146.171875 107.890625 L 158.21875 107.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.21875%,25.097656%,37.255859%)",
      fillOpacity: 1
    },
    d: "M 248.628906 194.449219 L 280.539063 189.011719 L 190.5 296.910156 L 248.171875 193.097656 L 249.070313 193.550781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.21875%,25.097656%,37.255859%)",
      fillOpacity: 1
    },
    d: "M 229.25 194.578125 L 190.5 296.910156 L 203.03125 200.921875 L 203.699219 201.011719 L 228.910156 194.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.21875%,25.097656%,37.255859%)",
      fillOpacity: 1
    },
    d: "M 177.960938 200.921875 L 190.5 296.910156 L 151.738281 194.578125 L 152.078125 194.449219 L 177.289063 201.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.21875%,25.097656%,37.255859%)",
      fillOpacity: 1
    },
    d: "M 132.820313 193.101563 L 190.5 296.910156 L 100.449219 189.011719 L 132.359375 194.449219 L 131.921875 193.550781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.21875%,25.097656%,37.255859%)",
      fillOpacity: 1
    },
    d: "M 164.078125 167.109375 L 164.820313 167.109375 L 164.820313 169.46875 L 152.078125 194.449219 L 151.738281 194.578125 L 151.148438 193.011719 L 132.820313 193.101563 L 131.921875 193.550781 L 131.910156 193.550781 L 119.800781 168.910156 L 119.558594 168.871094 L 119.890625 167.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.21875%,25.097656%,37.255859%)",
      fillOpacity: 1
    },
    d: "M 203.148438 199.980469 L 177.839844 199.980469 L 177.960938 200.921875 L 177.289063 201.007813 L 164.820313 169.46875 L 164.820313 167.109375 L 190.5 167.148438 L 216.171875 167.109375 L 216.171875 169.46875 L 203.699219 201.007813 L 203.03125 200.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.21875%,25.097656%,37.255859%)",
      fillOpacity: 1
    },
    d: "M 261.101563 167.050781 L 261.429688 168.871094 L 261.191406 168.910156 L 249.078125 193.550781 L 249.070313 193.550781 L 248.171875 193.101563 L 229.839844 193.011719 L 229.25 194.578125 L 228.910156 194.449219 L 216.171875 169.46875 L 216.171875 167.109375 L 216.910156 167.109375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.21875%,25.097656%,37.255859%)",
      fillOpacity: 1
    },
    d: "M 242.589844 107.890625 L 292.449219 159.980469 L 291 163.511719 L 261.429688 168.871094 L 261.101563 167.050781 L 234.820313 108 L 234.820313 107.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.21875%,25.097656%,37.255859%)",
      fillOpacity: 1
    },
    d: "M 222.769531 107.890625 L 216.910156 167.101563 L 190.5 107.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.21875%,25.097656%,37.255859%)",
      fillOpacity: 1
    },
    d: "M 190.5 107.890625 L 164.078125 167.101563 L 158.21875 107.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.21875%,25.097656%,37.255859%)",
      fillOpacity: 1
    },
    d: "M 146.171875 107.890625 L 146.171875 108 L 119.890625 167.050781 L 119.558594 168.871094 L 89.988281 163.511719 L 88.539063 159.980469 L 138.398438 107.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(58.789063%,93.75%,100%)",
      fillOpacity: 1
    },
    d: "M 384 192 C 384 217.101563 379.179688 241.078125 370.421875 263.050781 L 370.378906 263.03125 L 341.828125 268.710938 L 323.980469 242.070313 C 329.890625 226.511719 333.121094 209.628906 333.121094 192 C 333.121094 118.691406 277.230469 58.441406 205.730469 51.539063 L 205.75 51.328125 L 225.058594 25.269531 L 210.460938 0.878906 C 307.839844 10.160156 384 92.191406 384 192 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(42.358398%,87.889099%,97.65625%)",
      fillOpacity: 1
    },
    d: "M 337.910156 279.191406 L 365.820313 273.640625 C 335.140625 338.859375 268.839844 384 192 384 C 114.941406 384 48.488281 338.609375 17.921875 273.097656 L 17.960938 273.078125 L 33.410156 248.398438 L 65.039063 253.691406 L 65.050781 253.691406 C 87.929688 300.71875 136.179688 333.121094 192 333.121094 C 248.421875 333.121094 297.109375 300.007813 319.691406 252.160156 L 319.859375 252.238281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.097656%,85.546875%,95.701599%)",
      fillOpacity: 1
    },
    d: "M 194.769531 50.878906 L 194.769531 50.910156 C 193.851563 50.890625 192.929688 50.878906 192 50.878906 C 114.0625 50.878906 50.878906 114.058594 50.878906 192 C 50.878906 210.230469 54.339844 227.640625 60.628906 243.640625 L 60.460938 243.710938 L 28.46875 238.359375 L 13.359375 262.488281 C 4.730469 240.671875 0 216.890625 0 192 C 0 85.960938 85.960938 0 192 0 C 194.320313 0 196.621094 0.0390625 198.921875 0.121094 L 213.871094 25.109375 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRspec);
export default __webpack_public_path__ + "static/media/rspec.8fa790df683db71783dda48d6af80c4a.svg";
export { ForwardRef as ReactComponent };